export type CostCategory = 'consultant' | 'travel' | 'subcontractor' | 'equipment' | 'software' | 'other';

export interface ProjectCost {
  id: string;
  projectId: string;
  contractId?: string;
  category: CostCategory;
  consultantName?: string;
  description: string;
  amount: number;
  currency: 'USD' | 'EUR' | 'TRY';
  date: string;
  source?: 'manual' | 'timesheet';
  timesheetEntryId?: string;
}

export const COST_CATEGORY_LABELS: Record<CostCategory, string> = {
  consultant: 'Consultant Fee',
  travel: 'Travel & Accommodation',
  subcontractor: 'Subcontractor',
  equipment: 'Equipment & Materials',
  software: 'Software & Tools',
  other: 'Other',
};

export const COST_CATEGORY_COLORS: Record<CostCategory, string> = {
  consultant: 'bg-teal-100 text-teal-700',
  travel: 'bg-orange-100 text-orange-700',
  subcontractor: 'bg-purple-100 text-purple-700',
  equipment: 'bg-slate-100 text-slate-600',
  software: 'bg-green-100 text-green-700',
  other: 'bg-stone-100 text-stone-600',
};

export const mockProjectCosts: ProjectCost[] = [
  // ctr-001 / proj-009 — Wind Energy Feasibility
  { id: 'cost-001', projectId: 'proj-009', contractId: 'ctr-001', category: 'consultant', consultantName: 'Dr. Ahmet Yılmaz', description: 'Senior energy consultant — site assessment phase', amount: 12000, currency: 'USD', date: '2024-07-15' },
  { id: 'cost-002', projectId: 'proj-009', contractId: 'ctr-001', category: 'travel', description: 'Aegean region field visits — 3 trips', amount: 3200, currency: 'USD', date: '2024-08-10' },
  { id: 'cost-003', projectId: 'proj-009', contractId: 'ctr-001', category: 'subcontractor', description: 'Wind measurement equipment rental & data service', amount: 8500, currency: 'USD', date: '2024-09-01' },
  { id: 'cost-004', projectId: 'proj-009', contractId: 'ctr-001', category: 'software', description: 'WindPRO license — 6 months', amount: 1800, currency: 'USD', date: '2024-06-15' },
  // ctr-002 / proj-010 — MENA Market Entry
  { id: 'cost-005', projectId: 'proj-010', contractId: 'ctr-002', category: 'consultant', consultantName: 'Sara Al-Rashid', description: 'MENA market expert — research & analysis', amount: 8000, currency: 'USD', date: '2024-04-01' },
  { id: 'cost-006', projectId: 'proj-010', contractId: 'ctr-002', category: 'travel', description: 'Dubai client meetings — 2 trips', amount: 4500, currency: 'USD', date: '2024-05-20' },
  { id: 'cost-007', projectId: 'proj-010', contractId: 'ctr-002', category: 'subcontractor', description: 'Market research panel — MENA consumer data', amount: 3200, currency: 'USD', date: '2024-04-15' },
  // ctr-003 / proj-003 — TÜPRAŞ
  { id: 'cost-008', projectId: 'proj-003', contractId: 'ctr-003', category: 'consultant', consultantName: 'Prof. Kemal Aras', description: 'Structural engineering peer review', amount: 18000, currency: 'USD', date: '2021-09-01' },
  { id: 'cost-009', projectId: 'proj-003', contractId: 'ctr-003', category: 'consultant', consultantName: 'Eng. Fatma Demir', description: 'Process equipment seismic analysis', amount: 14000, currency: 'USD', date: '2021-12-01' },
  { id: 'cost-010', projectId: 'proj-003', contractId: 'ctr-003', category: 'travel', description: 'Izmit refinery site visits — 5 trips', amount: 4200, currency: 'USD', date: '2021-07-15' },
  { id: 'cost-011', projectId: 'proj-003', contractId: 'ctr-003', category: 'software', description: 'SAP2000 structural analysis license', amount: 2400, currency: 'USD', date: '2021-06-10' },
  { id: 'cost-012', projectId: 'proj-003', contractId: 'ctr-003', category: 'other', description: 'Report printing, translation & binding', amount: 850, currency: 'USD', date: '2022-03-10' },
];
